
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { QRCodeCanvas } from "qrcode.react";
import { Download } from "lucide-react";

interface QrDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  currentQrCode: string;
  currentQrUrl: string;
  onDownload: () => void;
}

export const QrDialog = ({
  isOpen,
  onOpenChange,
  currentQrCode,
  currentQrUrl,
  onDownload,
}: QrDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Código QR para {currentQrCode}</DialogTitle>
          <DialogDescription>
            Escanea este código QR para acceder al formulario con el código {currentQrCode}.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 flex flex-col items-center">
          <div className="p-4 bg-white rounded-lg">
            <QRCodeCanvas
              id="qr-code-canvas"
              value={currentQrUrl}
              size={250}
              level="H"
              includeMargin={true}
            />
          </div>
          <div className="mt-4 text-xs text-center text-muted-foreground">
            {currentQrUrl}
          </div>
        </div>
        <DialogFooter className="flex sm:justify-between">
          <div className="flex gap-2">
            <Button variant="outline" onClick={onDownload} className="gap-1">
              <Download className="h-4 w-4" />
              Descargar QR
            </Button>
          </div>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
